import { createApiCall } from 'lib/base';

const FETCH_INVESTCORE_USER_SURVEY_REPORT_DETAIL_API_ID =
  'DASHBOARD/FETCH_INVESTCORE_USER_SURVEY_REPORT_DETAIL_API';

const apiCall = createApiCall(
  FETCH_INVESTCORE_USER_SURVEY_REPORT_DETAIL_API_ID,
  ({ id }) => ({
    endpoint: `/api/admin/survey-reports/${id}`,
    method: 'GET',
  })
);

export default apiCall;
